const _require = require('lodash'),
  pick = _require.pick;
const _require2 = require('../lib/evaluateSource'),
  evaluateSources = _require2.evaluateSources;

/**
  * @function evalute - evaluate joinTableDiffBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const picked = pick(source, ['localColumn', 'localValues', 'relatedColumn', 'relatedOldValues', 'relatedNewValues']);
  const _await$evaluateSource = await evaluateSources(picked, content, parentContentPath, transientContext, nativeFunctions),
    localColumn = _await$evaluateSource.localColumn,
    _await$evaluateSource2 = _await$evaluateSource.localValues,
    localValues = _await$evaluateSource2 === void 0 ? [] : _await$evaluateSource2,
    relatedColumn = _await$evaluateSource.relatedColumn,
    _await$evaluateSource3 = _await$evaluateSource.relatedOldValues,
    relatedOldValues = _await$evaluateSource3 === void 0 ? [] : _await$evaluateSource3,
    _await$evaluateSource4 = _await$evaluateSource.relatedNewValues,
    relatedNewValues = _await$evaluateSource4 === void 0 ? [] : _await$evaluateSource4;
  const additions = relatedNewValues.filter(item => !relatedOldValues.includes(item));
  const removals = relatedOldValues.filter(item => !relatedNewValues.includes(item));
  const results = {
    additions: [],
    removals: []
  };
  for (let localIndex = 0; localIndex < localValues.length; localIndex += 1) {
    const localValue = localValues[localIndex];
    for (let additionsIndex = 0; additionsIndex < additions.length; additionsIndex += 1) {
      const item = {};
      item[localColumn] = localValue;
      item[relatedColumn] = additions[additionsIndex];
      results.additions.push(item);
    }
    for (let removalsIndex = 0; removalsIndex < removals.length; removalsIndex += 1) {
      const item = {};
      item[localColumn] = localValue;
      item[relatedColumn] = removals[removalsIndex];
      results.removals.push(item);
    }
  }
  return results;
};
module.exports = {
  evaluate
};